import script from "./PhoneTransferDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneTransferDialog.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneTransferDialog.vue?vue&type=style&index=0&id=679237c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-679237c8"]])

export default __exports__